import { useState, useEffect } from 'react';

// Hero images for the Daily Sign-In carousel
// First image is the ORIGINAL user's favorite - DO NOT REMOVE
const SIGNIN_HERO_IMAGES = [
  {
    url: "https://customer-assets.emergentagent.com/job_27431cfb-4e5b-42ec-9c1d-09979e5e6b73/artifacts/s1c5rjjx_image.png",
    alt: "Daily sign-in - original favorite"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/8e8a83cd-e63a-403d-8aa9-2fd4560e24e8/images/7341b7945b92945a5b3f9920d19a72dea91b90fa4a7053663f054b2482a24ca5.png",
    alt: "African American female teacher greeting child"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/8e8a83cd-e63a-403d-8aa9-2fd4560e24e8/images/1390cfdc4cd0d7e7f6abec4dc97c47c27bd4b9b71d9c412d94c612757be1c1d5.png",
    alt: "Diverse teaching team welcoming families at entrance"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/8e8a83cd-e63a-403d-8aa9-2fd4560e24e8/images/890764d2019cd8061eaba33726c8ce48f90af77a2d16c171116ac793a527a7b5.png",
    alt: "Black male teacher helping child with shoes"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/8e8a83cd-e63a-403d-8aa9-2fd4560e24e8/images/22b5d9d2470c50d981d3da80bf9a60f80121ae79f598f5f5e5459144c9087041.png",
    alt: "African American female teacher helping child with jacket"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/8e8a83cd-e63a-403d-8aa9-2fd4560e24e8/images/63c632fd13da696d04a131f206ede53547ce9167e64bea9feb3d16de8f472f80.png",
    alt: "Middle Eastern female teacher with hijab greeting child"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/8e8a83cd-e63a-403d-8aa9-2fd4560e24e8/images/2fa5e8aadccced4ec72ac2ad6489f25255f7988a8c5a859d456aea85f24cf1c8.png",
    alt: "Hispanic female teacher helping toddler with backpack"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/8e8a83cd-e63a-403d-8aa9-2fd4560e24e8/images/d1d50f60c4fb3e2f17ebde5c46dea2dd2e4552e742cf2fea8b8df1b0eebce385.png",
    alt: "Black female teacher high-fiving children at classroom door"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/8e8a83cd-e63a-403d-8aa9-2fd4560e24e8/images/b4e0a3bafea7ab36396b9397ed737b33fa502e7efacfd0a7effd02575f6dc26c.png",
    alt: "Teacher hugging child at daycare entrance"
  },
  {
    url: "https://static.prod-images.emergentagent.com/jobs/8e8a83cd-e63a-403d-8aa9-2fd4560e24e8/images/e8d9df017e7acd5f5e68a99c62ec7258a36848f2128fb19233ec0d197ba3d9f1.png",
    alt: "Teacher in yellow welcoming children with backpacks"
  }
];

const DailySignInHeroCarousel = ({ children }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-advance carousel every 6 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % SIGNIN_HERO_IMAGES.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div 
      className="relative rounded-2xl overflow-hidden mb-6 h-48 sm:h-56 md:h-64 lg:h-72 bg-blue-100"
      data-testid="daily-signin-hero-carousel"
    >
      {/* Background Images with Fade */}
      {SIGNIN_HERO_IMAGES.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            index === currentIndex ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={image.url}
            alt={image.alt}
            className="w-full h-full object-cover object-center"
            style={{ minWidth: '100%', minHeight: '100%' }}
          />
        </div>
      ))}

      {/* Subtle gradient overlay */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, rgba(255,255,255,0.50) 0%, rgba(240,248,255,0.45) 50%, rgba(255,245,250,0.45) 100%)'
        }}
      />

      {/* Content passed as children */}
      <div className="relative z-10 h-full flex items-center justify-center">
        {children}
      </div>

      {/* Subtle indicator dots */}
      <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 flex gap-2 print:hidden">
        {SIGNIN_HERO_IMAGES.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === currentIndex 
                ? 'bg-blue-600 w-4' 
                : 'bg-blue-400/50 hover:bg-blue-500/70'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default DailySignInHeroCarousel;
